import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { textLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy text envelope.
 *
 * `type: z.literal('zero')` is required here (no `.optional()`): a text widget
 * created inside a zero block must carry the tag end-to-end so downstream
 * consumers (positioning hosts, render branches) recognise the placement. The
 * host-app factory copies `meta.type` onto the entity at creation time.
 *
 * Inner data uses {@link textLegacyZeroDataSchema} — the extended-position
 * grid instead of the default variant's simple per-device grid.
 */
export const textLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('text'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: textLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
